export const updateVersion = (uiVersion: string, appVersion: string) => {
	document.body.setAttribute('data-ui-version', uiVersion);
	document.body.setAttribute('data-app-version', appVersion);
};
